"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimestamp = exports.clearLoader = exports.getTitansVersion = exports.extend = exports.isArray = exports.getNetworkType = exports.isIOS = exports.getOsByUA = exports.getVisitId = exports.getProtocolByUrl = exports.onPageHide = exports.getPagePath = exports.stringify = exports.getProtocol = exports.getOrigin = exports.addPerformanceObserver = exports.addEventToSelectors = exports.testTimeCost = exports.getNow = exports.isObject = exports.isFunction = exports.canUseGetEntriesByType = exports.getPageUrl = exports.calcTime = exports.getCookie = exports.deepCopy = void 0;
var tslib_1 = require("tslib");
var logger_1 = tslib_1.__importDefault(require("./logger"));
function deepCopy(target) {
    if (target === null) {
        return target;
    }
    if (target instanceof Array) {
        var cp_1 = [];
        target.forEach(function (v) {
            cp_1.push(v);
        });
        return cp_1.map(function (n) { return deepCopy(n); });
    }
    if (typeof target === 'object' && target !== {}) {
        var cp_2 = tslib_1.__assign({}, target);
        Object.keys(cp_2).forEach(function (k) {
            cp_2[k] = deepCopy(cp_2[k]);
        });
        return cp_2;
    }
    return target;
}
exports.deepCopy = deepCopy;
function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return null;
}
exports.getCookie = getCookie;
function calcTime(start, end) {
    return Math.max(Math.floor(end - start), 0);
}
exports.calcTime = calcTime;
function getPageUrl() {
    return window.location.href || '';
}
exports.getPageUrl = getPageUrl;
function canUseGetEntriesByType() {
    return window.performance && typeof window.performance.getEntriesByType === 'function';
}
exports.canUseGetEntriesByType = canUseGetEntriesByType;
function isFunction(fn) {
    return typeof fn === 'function';
}
exports.isFunction = isFunction;
function isObject(val) {
    return val !== null && typeof val === 'object';
}
exports.isObject = isObject;
function getNow() {
    return (performance === null || performance === void 0 ? void 0 : performance.now) && isFunction(performance.now) ? performance.now() : Date.now();
}
exports.getNow = getNow;
function testTimeCost(name, fn) {
    var result;
    console.time(name);
    try {
        result = fn();
    }
    catch (error) {
        logger_1.default.log('test time err', error);
    }
    console.timeEnd(name);
    return result;
}
exports.testTimeCost = testTimeCost;
function addEventToSelectors(selectors, name, cb) {
    if (selectors && selectors.length > 0) {
        selectors.forEach(function (id) {
            var container = document.getElementById(id);
            container && container.addEventListener(name, cb, false);
        });
    }
    else {
        window.addEventListener(name, cb, false);
    }
}
exports.addEventToSelectors = addEventToSelectors;
function addPerformanceObserver(name, cb) {
    if (window.PerformanceObserver && isFunction(window.PerformanceObserver)) {
        var supportedTypes = window.PerformanceObserver.supportedEntryTypes || [];
        if (supportedTypes.indexOf(name) === -1) {
            return;
        }
        var observer = new window.PerformanceObserver(cb);
        if (observer && isFunction(observer.observe)) {
            observer.observe({ entryTypes: [name] });
            return observer;
        }
    }
}
exports.addPerformanceObserver = addPerformanceObserver;
function getOrigin() {
    var origin = window.location.origin;
    if (!origin) {
        origin =
            window.location.protocol +
                '//' +
                window.location.hostname +
                (window.location.port ? ':' + window.location.port : '');
    }
    return origin;
}
exports.getOrigin = getOrigin;
function getProtocol() {
    return window.location.protocol;
}
exports.getProtocol = getProtocol;
function stringify(obj) {
    if (window.JSON && isFunction(JSON.stringify)) {
        var result = '';
        try {
            result = JSON.stringify(obj);
        }
        catch (error) {
            var cache_1 = [];
            result = JSON.stringify(obj, function (key, value) {
                if (typeof value === 'object' && value !== null) {
                    if (cache_1.indexOf(value) !== -1) {
                        // Circular reference found, discard key
                        return;
                    }
                    // Store value in our collection
                    cache_1.push(value);
                }
                return value;
            });
        }
        return result;
    }
    return obj === null || obj === undefined ? obj : obj.toString();
}
exports.stringify = stringify;
function getPagePath() {
    var index = window.location.href.indexOf('?');
    if (index > -1) {
        return window.location.href.slice(0, index);
    }
    return getPageUrl();
}
exports.getPagePath = getPagePath;
function onPageHide(cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
}
exports.onPageHide = onPageHide;
function getProtocolByUrl(url) {
    if (url.indexOf('https') === 0) {
        return 'https';
    }
    else if (url.indexOf('http') === 0) {
        return 'http';
    }
    return getProtocol().indexOf('https') === 0 ? 'https' : 'http';
}
exports.getProtocolByUrl = getProtocolByUrl;
/**
 * 用于计算当次访问的唯一标识 用于后端计算异常率计算 对PV 去重
 * @returns {string} visitId
 */
function getVisitId() {
    var visitId = '';
    try {
        visitId = ([1e7].toString() + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
            return (Number(c) ^
                (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (Number(c) / 4)))).toString(16);
        });
    }
    catch (err) {
        logger_1.default.log('get visitid err', err);
    }
    return visitId;
}
exports.getVisitId = getVisitId;
/**
 * 根据 UA 获取操作系统信息 支持常用操作系统
 * @param ua 浏览器 userAgent
 * @return {string} 操作系统   ios | Android | Mac OS | windows
 */
function getOsByUA(ua) {
    var osRegMap = {
        iOS: /iPhone|iPad/,
        Android: /Android/,
        Mac: /Mac\/sOS|/,
        Windows: /(W|w)indows/,
    };
    for (var _i = 0, _a = Object.keys(osRegMap); _i < _a.length; _i++) {
        var os = _a[_i];
        var reg = osRegMap[os];
        if (reg.test(ua)) {
            return os;
        }
    }
    return '';
}
exports.getOsByUA = getOsByUA;
function isIOS() {
    return /iPhone|iPad/.test(window.navigator.userAgent);
}
exports.isIOS = isIOS;
/**
 * 根据 ua 信息 和  navigator.connection 获取网络类型
 * @returns 网络连接类型
 */
function getNetworkType() {
    var _a, _b;
    var ua = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent;
    var networkReg = /NetType\/([a-zA-Z0-9]+)/;
    var regResult = ua ? ua.match(networkReg) : '';
    if (isArray(regResult)) {
        return regResult[1];
    }
    var connection = (_b = window.navigator) === null || _b === void 0 ? void 0 : _b.connection;
    return isObject(connection)
        ? connection.type === 'wifi'
            ? 'wifi'
            : connection.effectiveType || connection.type || ''
        : '';
}
exports.getNetworkType = getNetworkType;
function isArray(arr) {
    return isFunction(Array.isArray)
        ? Array.isArray(arr)
        : Object.prototype.toString.call(arr) === '[object Array]';
}
exports.isArray = isArray;
/** 简单 polyfill Object.assign */
function extend(target, source) {
    var ret = {};
    if (target) {
        Object.keys(target).forEach(function (key) {
            ret[key] = target[key];
        });
    }
    if (isObject(source)) {
        Object.keys(source).forEach(function (key) {
            var value = source[key];
            if (value !== undefined) {
                ret[key] = value;
            }
        });
    }
    return ret;
}
exports.extend = extend;
/** 获取当前 Titans宿主环境版本 返回 null 为非 Titans 环境 */
function getTitansVersion() {
    var regexp = function (str) {
        return new RegExp(str, 'i');
    };
    var lua = (navigator.userAgent + '').toLowerCase();
    var VER_REG_STR = '([0-9][0-9.a-zA-Z_]*)';
    var matchTitansVerison = lua.match(regexp('(TitansX|TitansNoX)/' + VER_REG_STR));
    return matchTitansVerison && matchTitansVerison[2];
}
exports.getTitansVersion = getTitansVersion;
function clearLoader() {
    var _perf_ = window._perf_;
    if (isObject(_perf_)) {
        _perf_.isReady = true;
        _perf_.js_error_queue = null;
        _perf_.unhandle_rejection_queue = null;
        _perf_.res_error_queue = [];
        _perf_.mutation_queue = [];
        if (_perf_.observer && isFunction(_perf_.observer.disconnect)) {
            _perf_.observer.disconnect();
            _perf_.observer = null;
        }
    }
}
exports.clearLoader = clearLoader;
function getTimestamp() {
    return Date.now();
}
exports.getTimestamp = getTimestamp;
//# sourceMappingURL=util.js.map